import React, { useEffect, useRef } from "react";
import "./CartPanel.css";

const CartPanel = ({ isOpen, onClose, cartItems }) => {
    const cartRef = useRef(null);
    const currentYear = new Date().getFullYear();

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (cartRef.current && !cartRef.current.contains(event.target)) {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen, onClose]);

    const handleBackClick = (e) => {
        e.stopPropagation();
        const backIcon = e.currentTarget;
        backIcon.style.transform = 'translateX(-10px)';
        
        setTimeout(() => {
            backIcon.style.transform = 'translateX(0)';
            onClose();
        }, 150);
    };

    return (
        <>
            <div className={`cart-overlay ${isOpen ? 'open' : ''}`} />
            <div 
                ref={cartRef}
                className={`cart-panel ${isOpen ? 'open' : ''}`}
            >
                <div className="cart-header">
                    <div className="header-left">
                        <button 
                            className="back-button-cart" 
                            onClick={handleBackClick}
                        >
                            <i className="fas fa-arrow-left"></i>
                        </button>
                    </div>
                    <h2>Your cart</h2>
                </div>

                <div className="cart-info-box">
                    <div className="info-icon">
                        <i className="fas fa-info-circle"></i>
                    </div>
                    <p>All your card items can be purchased by clicking on the items. Have fun shopping!</p>
                </div>

                <div className="year-selector">
                    <span>{currentYear}</span>
                    <i className="fas fa-chevron-down"></i>
                </div>

                <div className="cart-items">
                    {cartItems.map((item, index) => (
                        <div key={index} className="cart-item">
                            <div className="item-left">
                                <div className="item-image">
                                    <img src={item.image_url} alt={item.title} />
                                    <div className="price-tag">Rs. {item.price}</div>
                                </div>
                            </div>
                            <div className="item-right">
                                <div className="item-header">
                                    <h3>{item.title}</h3>
                                    <button className="more-options">
                                        <i className="fas fa-ellipsis-v"></i>
                                    </button>
                                </div>
                                <button className="purchase-now">
                                    Purchase Now
                                    <i className="fas fa-arrow-up-right"></i>
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default CartPanel; 